import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";

import NaytaPaluuNappi from "./NaytaPaluuNappi";
import tuotelista from "./json/tuotteet tuotantoon";

const Tilaa = (props) => {
  const { tila, asetatila } = props;
  const { maksutapa } = useParams();
  const navigate = useNavigate();
  const [maa, setMaa] = useState("Suomi");
  const [nimi2, asetaNimi2] = useState("");
  const [sposti2, asetaSposti2] = useState("");
  const [puhno2, asetaPuhno2] = useState("");

  async function handleClick(event) {
    event.preventDefault();
    let tuotteet = "";
    tila.kori.forEach((lkm, tid) => {
      if (tid === "lkm") tuotteet += "Lkm yhteensä: " + lkm + "<br>";
      else {
        const tuote = tuotelista.filter((t) => t.Ttunnus === tid)[0];
        tuotteet +=
          tuote.Tuote +
          " Lkm: " +
          lkm +
          " Hinta: " +
          tuote.Hinta +
          "€ (Tunnus: " +
          tuote.Ttunnus +
          ")<br>";
      }
    });
    tuotteet += "<br>Toimitustapa: " + maksutapa;
    const arvot = {
      nimi: document.getElementById("nimi").value,
      sposti: document.getElementById("sposti").value,
      puhno: document.getElementById("puhno").value,
      toimitustapa: maksutapa,
      katuosoite: document.getElementById("katuosoite").value,
      postiosoite: document.getElementById("postiosoite").value,
      maa,
      nimi2,
      sposti2,
      puhno2,
      viesti: document.getElementById("viesti").value,
      listalle: document.getElementById("listalle").checked,
      tuotteet,
    };
    // alert(JSON.stringify(arvot))
    // const formData = new FormData(event.target);
    // const arvot2 = Object.fromEntries(formData);
    // alert(JSON.stringify(arvot2))

    try {
      emailjs.send(
        "gaimport_gmail",
        "gaimport_tilaus",
        arvot,
        "user_8NJv4ALN1zZmt4OSY0NeC",
      );
      asetatila("kori", { 0: 0 });
      navigate("/kiitos");
    } catch (err) {
      alert("Lähetysvirhe: " + err.message + "\nYritä myöhemmin uudelleen.");
      navigate("/");
    }
  }
  function handleChange(event) {
    event.preventDefault();
    const etid = event.target.id;
    const etv = event.target.value;
    if (etid === "nimi" || etid === "nimi2") asetaNimi2(etv);
    if (etid === "sposti" || etid === "sposti2") asetaSposti2(etv);
    if (etid === "puhno" || etid === "puhno2") asetaPuhno2(etv);
  }

  const posti = maksutapa === "posti";
  const paksu = "isoteksti" + (posti ? " paksu" : "");
  const teksti = posti ? "(Tekstari postituksesta)" : "";
  const pakko = posti ? "Pakollinen" : "";
  const puhno = posti ? "Pakollinen" : "Suositeltava";

  return (
    <form>
      <table>
        <tr>
          <td className="isoheader paksu" colSpan={2}>
            <label for="nimi">Maksaja:</label>
          </td>
        </tr>
        <tr>
          <td className="isoteksti paksu" width={100}>
            <label for="nimi">Nimi:</label>
          </td>
          <td>
            <input
              className="leveys"
              type="text"
              id="nimi"
              name="nimi"
              autoFocus
              placeholder="Pakollinen"
              onChange={handleChange}
            />
          </td>
        </tr>
        <tr>
          <td className="isoteksti paksu">
            <label for="sposti">Sähköpostiosoite:</label>
          </td>
          <td>
            <input
              className="leveys"
              type="text"
              id="sposti"
              name="sposti"
              placeholder="Pakollinen"
              onChange={handleChange}
            />
          </td>
        </tr>
        <tr>
          <td className="isoteksti paksu">
            <label for="puhno">Puhelinnumero:</label>
          </td>
          <td>
            <input
              className="leveys"
              type="text"
              id="puhno"
              name="puhno"
              placeholder={puhno}
              onChange={handleChange}
            />
          </td>
        </tr>
      </table>
      <table style={{ display: posti ? "table" : "none" }}>
        <tr>
          <th className="isoheader paksu" colSpan={2}>
            <label for="nimi">Toimitusosoite:</label>
          </th>
        </tr>
        <tr>
          <td id="kotiosoite" className={paksu} width={120}>
            <label for="katuosoite">
              Katuosoite:
              <br />
              <span className="pikkuteksti">esim. Jalaskuja 10 D</span>
            </label>
          </td>
          <td>
            <input
              className="leveys"
              type="text"
              id="katuosoite"
              name="katuosoite"
              placeholder={pakko}
            />
          </td>
        </tr>
        <tr>
          <td className={paksu}>
            <label for="postiosoite">
              Postiosoite:
              <br />
              <span className="pikkuteksti">esim. 00750 Helsinki</span>
            </label>
          </td>
          <td>
            <input
              className="leveys"
              type="text"
              id="postiosoite"
              name="postiosoite"
              placeholder={pakko}
            />
          </td>
          <input type="hidden" id="maa" name="maa" value={maa} />
        </tr>
      </table>
      <table>
        <tr>
          <td className="isoheader paksu" colSpan={2}>
            Vastaanottaja:
          </td>
        </tr>
        <tr>
          <td className="isoteksti paksu" width={100}>
            <label for="nimi2">Nimi:</label>
          </td>
          <td>
            <input
              className="leveys"
              type="text"
              id="nimi2"
              name="nimi2"
              autoFocus
              placeholder="Pakollinen"
              value={nimi2}
              onChange={handleChange}
            />
          </td>
        </tr>
        <tr>
          <td className="isoteksti paksu">
            <label for="sposti2">Sähköpostiosoite:</label>
          </td>
          <td>
            <input
              className="leveys"
              type="text"
              id="sposti2"
              name="sposti2"
              placeholder="Pakollinen"
              value={sposti2}
              onChange={handleChange}
            />
          </td>
        </tr>
        <tr>
          <td className="isoteksti paksu">
            <label for="puhno2">
              Puhelinnumero:
              <br />
              <span className="pikkuteksti">{teksti}</span>
            </label>
          </td>
          <td>
            <input
              className="leveys"
              type="text"
              id="puhno2"
              name="puhno2"
              placeholder={puhno}
              value={puhno2}
              onChange={handleChange}
            />
          </td>
        </tr>
      </table>
      <table>
        <tr>
          <td className="isoteksti" width={120}>
            Toimitustapa:
          </td>
          <td align="left">
            &nbsp;
            {maksutapa.charAt(0).toUpperCase() + maksutapa.substring(1)}
            {/* <input
              type="hidden"
              id="toimitustapa"
              name="toimitustapa"
              value={maksutapa}
            /> */}
          </td>
        </tr>
        <tr>
          <td className="isoteksti paksu" width={120}>
            <label for="viesti">Viesti:</label>
          </td>
          <td>
            <textarea name="viesti" id="viesti" className="viesti" cols={23} />
          </td>
        </tr>
      </table>
      <table>
        <tr cols={3}>
          <td className="isoteksti paksu" width={120}>
            Asiakastiedote:
          </td>
          <td>
            {" "}
            <input type="checkbox" id="listalle" />
          </td>
          <td className="pieniteksti">
            Minulle saa lähettää Gaimport
            <br />
            Ky:n sähköisen asiakastiedotteen
            <br />
            muutaman kerran vuodessa.
          </td>
        </tr>
      </table>
      <button
        className="nappi nappi1 koriNappi"
        onClick={handleClick}
        title="Lähetä tilaus"
      >
        Lähetä
      </button>
      <NaytaPaluuNappi kohde={"/kori"} />
    </form>
  );
};
export default Tilaa;
